import React from 'react'

import { NavLink } from 'react-router-dom'

const FwdRefNavLink = React.forwardRef(function Link(props, ref) {
  return (
    <NavLink
      innerRef={ref}
      {...props}
    />
  )
})

export default FwdRefNavLink
